import { Component, OnDestroy, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { BroadcastService } from '../../common/services/broadcast/broadcast.service';
import { CommonEvents } from '../../common/enums/common-events.enum';
import { BehaviorSubject, Subscription } from 'rxjs';


@Component({
    selector: 'cas-main-title',
    templateUrl: './main-title.component.html',
    styleUrls: ['./main-title.component.scss'],
    animations: [
        trigger('titleChanged', [
            state('start', style({
                position: 'relative',
                top: '100%',
                opacity: 0
            })),
            state('end', style({
                position: 'relative',
                top: 0,
                opacity: 1
            })),
            transition('void => end', [
                animate('250ms')
            ]),
            transition('start => end', [
                animate('250ms')
            ])
        ])
    ]
})
export class MainTitleComponent implements OnInit, OnDestroy {

    constructor(private broadcastService: BroadcastService) {
    }

    public state: BehaviorSubject<string> = new BehaviorSubject('');
    public title: BehaviorSubject<string> = new BehaviorSubject('');

    private _title: string;

    private titleTimeout: any;
    private stateTimeout: any;

    private isStart = true;
    private changeTitleSubscription: Subscription;

    private static tryClean(timeout) {
        if (timeout) {
            clearTimeout(timeout);
        }
    }

    public ngOnInit() {
        this.changeTitleSubscription = this.broadcastService
            .on(CommonEvents.ChangeTitle)
            .subscribe((title: string) => this.setTitle(title));
    }

    public ngOnDestroy() {
        this.changeTitleSubscription?.unsubscribe();
    }

    private setTitle(title: string) {
        if (title === this._title) {
            return;
        }
        this._title = title;

        MainTitleComponent.tryClean(this.stateTimeout);
        MainTitleComponent.tryClean(this.titleTimeout);

        this.stateTimeout = setTimeout(() => this.state.next(this.isStart ? 'end' : 'start'));
        this.titleTimeout = setTimeout(() => this.title.next(title));

        this.isStart = !this.isStart;
    }
}
